module.exports = __webpack_public_path__ + "static/media/coronavirus-lp-small.9a927811.svg";